import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import Button from 'react-bootstrap/Button';

import { useTranslation } from 'react-i18next';
import InformationBookingCard from './InformationBookingCard';
import GuestCard from '../guests/components/GuestCard';
import { useGetGuestsMutation } from '../../services/majesticResortsApi';
import { isEmptyObject } from '../../utils';
import MessageErrorModal from '../../ui/Modals/MessageErrorModal';

import purgeReducers from '../../utils/purgeReducers';
import usePageNavigation from '../../hooks/usePageNavigation';
import { setErrorMajestic, setErrorMessage } from '../../app/store/majesticSlice';
import { setGuestHolder } from '../guests/guestsSlice';
import ErrorMessageOcrModal from '../../ui/Modals/ErrorMessageOcrModal';
import CustomErrorModal from '../../ui/Modals/CustomErrorModal';

function BookingPage() {
  const { t } = useTranslation();
  const { hotel } = useSelector((state) => state.checking);
  const { booking } = useSelector((state) => state.booking);
  const { guestList, guestHolder } = useSelector((state) => state.guests);
  const [allowContinue, setAllowContinue] = useState(false);
  const [existError, setExistError] = useState(false);
  const [getGuests, { isLoading, isError, error }] = useGetGuestsMutation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { navigateNextPage } = usePageNavigation();

  useEffect(() => {
    if (guestList.length > 0) {
      const checkinCompletedList = guestList.filter((item) => item.IDHuesped !== '');
      setAllowContinue(checkinCompletedList.length === guestList.length);

      const findedGuestHolder = guestList.find((item) => item.NumeroCliente === '01');
      if (typeof findedGuestHolder === 'undefined') {
        dispatch(setErrorMessage({ message: t('TXT_WARNING_NOT_FINDED_GUEST_HOLDER') }));
        return;
      }

      dispatch(setGuestHolder(findedGuestHolder));
    }
  }, [dispatch, guestList]);

  useEffect(() => {
    const clearReducers = async () => {
      await purgeReducers(['ocr', 'guests'], { keepToken: true });
      if (hotel !== '' && !isEmptyObject(booking)) {
        getGuests({ hotel, reservationNumber: booking.NumReserva });
      }
    };

    clearReducers();
  }, [getGuests, hotel, booking]);

  const handleNextPage = () => {
    if (!allowContinue) {
      dispatch(setErrorMajestic({ message: t('TXT_ERROR_GUEST_NO_CKECKIN') }));
      setExistError(true);
      return;
    }

    if (allowContinue && booking?.PreCheckIn === 'X') {
      navigateNextPage('');
      return;
    }

    if (allowContinue && booking?.PreCheckIn === '') {
      navigateNextPage('BookingMotive');
    }
  };

  const handleChangeErrorExist = () => {
    setExistError(false);
  };

  return (
    <div className="booking__content d-flex flex-column h-100 position-relative">
      <div className="text-center">
        <p className="mb-0 app-txt-granite pp-fw-figtree-regular">{t('TXT_TITLE_CHECK_IN')}</p>

        <p className="mb-2 app-fs-h4 app-fw-notosans-bold pt-2 app-txt-granite">
          {t('TXT_WELCOME_BOOKING', { guestNameHolder: guestHolder.Nombre_Pila || '-' })}
        </p>
        <p className="mb-0 app-txt-granite-80-dark app-fw-notosans-regular">{t('TXT_REGISTER_GUEST')}</p>
      </div>

      {/* Information Booking Card */}
      <div className="mt-2 mb-2">
        <InformationBookingCard />
      </div>
      {/* Information Booking Card */}

      {/* Guest List Card */}
      {guestList.map((guest) => (
        <div className="mb-2" key={guest.customId}>
          <GuestCard
            guestCheckIn={guest.IDHuesped}
            guestId={guest.customId}
            guestTypeId={guest.TipoPersona}
            guestNumber={guest.customNumber}
            guestName={guest.Nombre_Pila}
            guestLastName={guest.Nombre}
            guestNumberClient={guest.NumeroCliente}
          />
        </div>
      ))}
      {/* END Guest List Card */}

      <div className="d-flex flex-grow-1 align-items-end pb-2">
        <Button
          // disabled={booking?.PreCheckIn === 'X' ? true : !allowContinue}
          variant=""
          onClick={handleNextPage}
          className="app-bg-sand app-fw-notosans-bold app-txt-granite w-100 rounded-3 btn-height border-0"
        >
          {t((allowContinue && booking?.PreCheckIn === 'X' ? 'TXT_BTN_GETOUT' : 'TXT_BOTON_CONTINUE'))}
        </Button>
      </div>

      {/* {isLoading && <LoaderSpinner />} */}
      {/* {isError && <MessageErrorModal message={error.message} />} */}
      {existError && <CustomErrorModal handleCloseModal={handleChangeErrorExist} />}
      {isError && <ErrorMessageOcrModal />}
    </div>
  );
}

export default BookingPage;
